// extracted by mini-css-extract-plugin
export var bgImage = "_2m-x";
export var body = "_2m-w";
export var buttonBar = "_2m-6";
export var card = "_2m-0";
export var center = "_2m-11";
export var chevron = "_2m-15";
export var clickable = "_2m-4";
export var closeButton = "_2m-13";
export var collapseHeader = "_2m-7";
export var collapseIcon = "_2m-d";
export var collapseSection = "_2m-b";
export var collapseTitle = "_2m-a";
export var collapseTrigger = "_2m-8";
export var collapsed = "_2m-c";
export var dark = "_2m-1";
export var expandableCard = "_2m-16";
export var expandableCardTitle = "_2m-14";
export var grid = "_2m-5";
export var header = "_2m-f";
export var headerContainer = "_2m-e";
export var headerSubtitle = "_2m-k";
export var headerTitle = "_2m-g";
export var inherit = "_2m-9";
export var large = "_2m-i";
export var left = "_2m-12";
export var linkColor = "_2m-17";
export var medium = "_2m-j";
export var noPadding = "_2m-3";
export var outlined = "_2m-p";
export var scrollable = "_2m-2";
export var section = "_2m-o";
export var sectionHeader = "_2m-s";
export var selected = "_2m-q";
export var separator = "_2m-r";
export var subsection = "_2m-t";
export var subtitle = "_2m-u";
export var subtotalCollapseHeader = "_2m-y";
export var subtotalCollapseHeaderTitle = "_2m-z";
export var subtotalItem = "_2m-10";
export var table = "_2m-l";
export var tableCell = "_2m-n";
export var tableHeader = "_2m-m";
export var title = "_2m-v";
export var titleFullWidth = "_2m-h";